import { colors } from '../../../../../../../colors';
import { FaChevronUp, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

import './index.css';
import { DomainTuple } from 'victory';

interface Props {
  zoomedDomain:
    | {
        x: DomainTuple;
        y: DomainTuple;
      }
    | undefined;
  selectedChartTypesLength: number;
  handleZoomLeft: () => void;
  handleZoomOut: () => void;
  handleZoomRight: () => void;
}

const ChartZoomOptions = (props: Props) => {
  const {
    zoomedDomain,
    selectedChartTypesLength,
    handleZoomLeft,
    handleZoomOut,
    handleZoomRight,
  } = props;

  if (!zoomedDomain) {
    return null;
  }

  return (
    <div
      className="single-profit-calcs-chart-zoom-options-container"
      style={{ left: `${selectedChartTypesLength * 5}vw` }}
    >
      <div className="single-profit-calcs-chart-zoom-options-container-icon">
        <FaChevronLeft color={colors.white} onClick={handleZoomLeft} />
      </div>
      <div className="single-profit-calcs-chart-zoom-options-container-down">
        <FaChevronUp color={colors.white} onClick={handleZoomOut} />
      </div>
      <div className="single-profit-calcs-chart-zoom-options-container-icon">
        <FaChevronRight color={colors.white} onClick={handleZoomRight} />
      </div>
    </div>
  );
};

export default ChartZoomOptions;
